import React from 'react';
import { PageProviderDataContext } from '@base-providers';
import { BaseFilterEntity, PageProviderDataEntity } from '@base-entities';

export function usePageProviderData<FilterEntity extends BaseFilterEntity = BaseFilterEntity>() {
  return React.useContext<PageProviderDataEntity<FilterEntity>>(PageProviderDataContext);
}
